var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "500", persistent: "", "content-class": "mainModal" },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("v-card", { staticClass: "cardModal", attrs: { elevation: "0" } }, [
        _c("div", { staticClass: "input-wrapper textAreaModal" }, [
          _c("h2", { staticClass: "titleSection text-center" }, [
            _vm._v("Nueva Version Encontrada")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Se ha detectado una nueva versión a utilizar. Es requerido actualizar"
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-center justify-center" },
          [
            _c(
              "v-btn",
              {
                attrs: { color: "success", depressed: "" },
                on: {
                  click: function($event) {
                    return _vm.refresh()
                  }
                }
              },
              [_vm._v("\n          Actualizar\n        ")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f950a88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f950a88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReloadRequired.vue
// module id = 196
// module chunks = 1